import React from 'react';

export const withStandardInputProps = (WrappedComponent) => (props) => (
  <WrappedComponent resettable variant="outlined" {...props} />
);
